/**
 * 倉庫関連のQuery Hooks
 */

import { useQuery } from '@tanstack/react-query';
import { useAuthHeader } from '@/hooks/useAuth';
import { getWarehouses } from '@/lib/api/warehouse';
import { warehouseKeys } from '../keys';
import { CACHE_TIME } from '../client';

/**
 * 倉庫一覧を取得するQuery Hook
 * @param accountCode アカウントコード
 */
export function useWarehouses(accountCode: string) {
  const { getAuthHeader, isLoading: authHeaderLoading, isAuthorized } = useAuthHeader();

  return useQuery({
    queryKey: warehouseKeys.list(accountCode),
    queryFn: async () => {
      const authHeaders = getAuthHeader();
      return getWarehouses(accountCode, authHeaders);
    },
    enabled: !authHeaderLoading && isAuthorized && !!accountCode,
    staleTime: CACHE_TIME.ACCOUNTS_LIST,
  });
}
